import {PaymentMethodType} from '@vio/core/src/api-types/bovio/request/booking_creation'

type PaymentMethodRankingType = Record<
  string,
  {
    mobile: PaymentMethodType[]
    desktop: PaymentMethodType[]
  }
>

/* Country used when the user's country has no dedicated ranking. */
export const FALLBACK_COUNTRY = 'RoW'

export const DEFAULT_PAYMENT_METHODS_ORDER = [
  PaymentMethodType.Card,
  PaymentMethodType.Ideal,
  PaymentMethodType.Vipps,
  PaymentMethodType.ApplePay,
  PaymentMethodType.Klarna,
  PaymentMethodType.Paypal,
  PaymentMethodType.GooglePay,
  PaymentMethodType.RevolutPay
]

export const PAYMENT_METHODS_RANKING: PaymentMethodRankingType = {
  NL: {
    mobile: [
      PaymentMethodType.Ideal,
      PaymentMethodType.ApplePay,
      PaymentMethodType.GooglePay,
      PaymentMethodType.Card,
      PaymentMethodType.Paypal,
      PaymentMethodType.Klarna,
      PaymentMethodType.RevolutPay
    ],
    desktop: [
      PaymentMethodType.Ideal,
      PaymentMethodType.Card,
      PaymentMethodType.Paypal,
      PaymentMethodType.ApplePay,
      PaymentMethodType.GooglePay,
      PaymentMethodType.Klarna,
      PaymentMethodType.RevolutPay
    ]
  },
  NO: {
    mobile: [
      PaymentMethodType.Vipps,
      PaymentMethodType.ApplePay,
      PaymentMethodType.GooglePay,
      PaymentMethodType.Card,
      PaymentMethodType.Paypal,
      PaymentMethodType.Klarna,
      PaymentMethodType.RevolutPay
    ],
    desktop: [
      PaymentMethodType.Vipps,
      PaymentMethodType.Card,
      PaymentMethodType.Paypal,
      PaymentMethodType.ApplePay,
      PaymentMethodType.GooglePay,
      PaymentMethodType.Klarna,
      PaymentMethodType.RevolutPay
    ]
  },
  US: {
    mobile: [
      PaymentMethodType.ApplePay,
      PaymentMethodType.GooglePay,
      PaymentMethodType.Card,
      PaymentMethodType.Klarna
    ],
    desktop: [
      PaymentMethodType.Card,
      PaymentMethodType.ApplePay,
      PaymentMethodType.GooglePay,
      PaymentMethodType.Klarna
    ]
  },
  [FALLBACK_COUNTRY]: {
    mobile: [
      PaymentMethodType.Card,
      PaymentMethodType.ApplePay,
      PaymentMethodType.GooglePay,
      PaymentMethodType.Ideal,
      PaymentMethodType.RevolutPay,
      PaymentMethodType.Vipps,
      PaymentMethodType.Paypal,
      PaymentMethodType.Klarna
    ],
    desktop: [
      PaymentMethodType.Card,
      PaymentMethodType.ApplePay,
      PaymentMethodType.GooglePay,
      PaymentMethodType.Ideal,
      PaymentMethodType.RevolutPay,
      PaymentMethodType.Vipps,
      PaymentMethodType.Paypal,
      PaymentMethodType.Klarna
    ]
  }
}
